import { useEffect, MouseEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IStore, State } from "../DataTypes/storeTypes";
import { onLogoutClicked, updateState, updateClientPublicId } from "../Actions/actions";
import { listenEvent, EventNames, detachListener } from "../../portalEvents";
import { Button, Menu, MenuItem } from "@powerdiary/components-library/lib";
import { faChevronDown, faChevronUp, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, useMediaQuery, useTheme } from "@mui/material";

const NavigationBar = () => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const open = Boolean(anchorEl);

    const dispatch = useDispatch();

    const clientName = useSelector((state: IStore) => state.common.clientName);
    const appointmentsUrl = useSelector((state: IStore) => state.initialSettings.appointmentsUrl);
    const hideLoginButton = useSelector((state: IStore) => state.initialSettings.hideLoginButton);
    const shouldShowClientPortalLogin = useSelector(
        (state: IStore) => state.initialSettings.organisationInfo.shouldShowClientPortalLogin
    );

    const openMenu = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const closeMenu = () => {
        setAnchorEl(null);
    };

    const onLogOutClicked = () => {
        dispatch(onLogoutClicked());
    };

    const onLogInClicked = () => {
        dispatch(updateState(State.Login));
    };

    const onSetExistingClientCredentialsClicked = (data: any) => {
        dispatch(updateState(State.SetExistingClientCredentials));
        dispatch(updateClientPublicId(data));
    };

    useEffect(() => {
        listenEvent(EventNames.ShowLogin, onLogInClicked);
        listenEvent(EventNames.ShowSetExistingClientCredentials, onSetExistingClientCredentialsClicked);

        return () => {
            detachListener(EventNames.ShowSetExistingClientCredentials, onSetExistingClientCredentialsClicked);
            detachListener(EventNames.ShowLogin, onLogInClicked);
        };
    }, [onLogInClicked, onSetExistingClientCredentialsClicked]);

    if (hideLoginButton) {
        return null;
    }

    if (!clientName && shouldShowClientPortalLogin) {
        return (
            <Button variant="outlined" size="small" labelCaseSensitive onClick={onLogInClicked}>
                Log in
            </Button>
        );
    }

    return (
        shouldShowClientPortalLogin && (
            <>
                {isMobile ? (
                    <Button variant="outlined" onClick={openMenu} size="small">
                        <FontAwesomeIcon size="lg" icon={faBars} />
                    </Button>
                ) : (
                    <Button
                        id="user_button"
                        variant="outlined"
                        size="small"
                        onClick={openMenu}
                        aria-controls={open ? "user_menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        labelCaseSensitive
                    >
                        <Box display="flex" alignItems="center" gap="8px">
                            {clientName}
                            {open ? (
                                <FontAwesomeIcon size="sm" icon={faChevronUp} />
                            ) : (
                                <FontAwesomeIcon size="sm" icon={faChevronDown} />
                            )}
                        </Box>
                    </Button>
                )}

                <Menu
                    id="user_menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={closeMenu}
                    MenuListProps={{
                        "aria-labelledby": "user_button",
                    }}
                >
                    <MenuItem
                        onClick={() => {
                            location.href = appointmentsUrl;
                        }}
                    >
                        My Appointments
                    </MenuItem>
                    <MenuItem onClick={onLogOutClicked}>Log out</MenuItem>
                </Menu>
            </>
        )
    );
};

export default NavigationBar;
